// ── Shared Constants — extracted from lumio.jsx ────────────────

// ── UPDATE WITH YOUR RAILWAY URL ─────────────────────────────
export const SPARKY_SERVER_URL = "https://sparky-app-production.up.railway.app";

// ── DESIGN TOKENS ─────────────────────────────────────────────
export const T = {
  // ── Empirio student-first design (2026-11-03): soft lavender ground + indigo, the same as Today/Learn/Me ──
  bg:        "#F6F5FC",
  surface:   "#FFFFFF",
  card:      "#FFFFFF",
  border:    "#E2E0F0",
  borderHi:  "#C9C8FF",
  text:      "#1B1B23",
  textMid:   "#45435A",
  textDim:   "#6E6C80",
  // ── Primary accent — Empirio indigo ─────────────────────────
  accent:    "#5B5CF0",
  accentDk:  "#3D3AB8",
  accentLo:  "#ECEBFE",
  accentMid: "#A5A6F6",
  // ── Lumi gold ─────────────────────────────────────────────
  gold:      "#D4A020",
  goldLo:    "#FEF7E0",
  // ── Semantic ──────────────────────────────────────────────
  green:     "#059669",
  greenLo:   "#ECFDF5",
  red:       "#DC2626",
  redLo:     "#FFF1F2",
  purple:    "#7C3AED",
  purpleLo:  "#FAF5FF",
  coral:     "#F97316",
  coralLo:   "#FFF7ED",
};

export const MIN_QUESTIONS_FOR_PCT = 10;

export const SUBJECTS = [
  { id:"reading",  label:"Reading",             short:"READ", icon:"\u{1F4D6}", color:"#3B82F6", lo:"#1D3A6E", desc:"Comprehension, inference & analysis" },
  { id:"writing",  label:"Writing",             short:"WRIT", icon:"\u270D\uFE0F",  color:"#8B5CF6", lo:"#1E1040", desc:"Narrative, persuasive & structure" },
  { id:"language", label:"Language Conventions", short:"LANG", icon:"\u{1F524}", color:"#10B981", lo:"#0A2E20", desc:"Spelling, grammar & punctuation" },
  { id:"numeracy", label:"Numeracy",            short:"NUM",  icon:"\u{1F4D0}", color:"#F59E0B", lo:"#3D2F0A", desc:"Maths reasoning & problem solving" },
  { id:"thinking", label:"Thinking Skills",     short:"THINK",icon:"\u{1F9E0}", color:"#EF4444", lo:"#3D0A0A", desc:"Critical thinking & logical reasoning" },
  { id:"science",  label:"Science",             short:"SCI",  icon:"\u{1F52C}", color:"#06B6D4", lo:"#0A2E35", desc:"Scientific inquiry & reasoning" },
  { id:"digital",  label:"Digital Technologies",short:"DIGI", icon:"\u{1F4BB}", color:"#6366F1", lo:"#1A1040", desc:"Computing, algorithms & digital literacy" },
  { id:"english",  label:"English",              short:"ENG",  icon:"\u{1F4D6}", color:"#0D9488", lo:"#0D1F1F", desc:"Reading comprehension, language & critical thinking" },
  { id:"spelling", label:"Spelling Bee",          short:"SPELL",icon:"\u{1F524}", color:"#F97316", lo:"#2D1500", desc:"Spelling, vocabulary & word knowledge" },
  { id:"biology",  label:"Biology",               short:"BIO",  icon:"🔬", color:"#10B981", lo:"#0A2E20", desc:"Cells, genetics, evolution & ecosystems" },
  { id:"chemistry",label:"Chemistry",             short:"CHEM", icon:"⚗️", color:"#F59E0B", lo:"#3D2F0A", desc:"Equilibrium, acids/bases, organic & quantitative chemistry" },
];

// Which subjects to show per exam program
export const EXAM_SUBJECTS = {
  naplan:        ["reading","writing","language","numeracy"],
  selective_nsw: ["reading","numeracy","thinking","writing"],
  oc:            ["reading","numeracy","thinking"],
  acer:          ["reading","numeracy","writing"],
  ignite:        ["reading","thinking","numeracy","writing"],
  vic_selective: ["reading","thinking","numeracy","writing"],
  icas:          ["english","numeracy","science","digital","writing","spelling"],
  hsc:           ["english_advanced","english_standard","mathematics_advanced","mathematics_extension_1","mathematics_standard_2","biology","chemistry","physics","modern_history","legal_studies","economics","business_studies"],
  vce:           ["english","mathematical_methods","further_mathematics","specialist_mathematics","biology","chemistry","physics","legal_studies","economics","accounting","business_management","global_politics","history_revolutions"],
};

// HSC subject metadata for Year 12 subject picker
export const HSC_SUBJECTS = [
  { id:"english_advanced",       label:"English Advanced",          short:"ENG ADV", icon:"\uD83D\uDCD6", color:"#0D9488", desc:"Module-based close reading, creative & critical essays" },
  { id:"english_standard",       label:"English Standard",          short:"ENG STD", icon:"\uD83D\uDCDD", color:"#14B8A6", desc:"Common module + electives with source-based analysis" },
  { id:"mathematics_advanced",   label:"Mathematics Advanced",      short:"MATH ADV",icon:"\u222B",        color:"#8B5CF6", desc:"Calculus, statistics, financial maths & modelling" },
  { id:"mathematics_extension_1",label:"Mathematics Extension 1",   short:"EXT 1",   icon:"\uD83E\uDDEE", color:"#7C3AED", desc:"Vectors, proofs, binomial distribution & further calculus" },
  { id:"mathematics_standard_2", label:"Mathematics Standard 2",    short:"MATH STD",icon:"\uD83D\uDCD0", color:"#06B6D4", desc:"Networks, statistics, financial maths & measurement" },
  { id:"biology",                label:"Biology",                   short:"BIO",     icon:"\uD83D\uDD2C", color:"#10B981", desc:"Cells, genetics, evolution & ecosystems" },
  { id:"chemistry",              label:"Chemistry",                 short:"CHEM",    icon:"\u2697\uFE0F", color:"#F59E0B", desc:"Equilibrium, acids/bases, organic & quantitative chemistry" },
  { id:"physics",                label:"Physics",                   short:"PHYS",    icon:"\u269B\uFE0F", color:"#3B82F6", desc:"Mechanics, electromagnetism, quantum & relativity" },
  { id:"modern_history",         label:"Modern History",            short:"MOD HIST",icon:"\uD83C\uDFDB\uFE0F", color:"#EF4444", desc:"World War I, interwar, World War II & rights movements" },
  { id:"legal_studies",          label:"Legal Studies",             short:"LEGAL",   icon:"\u2696\uFE0F", color:"#F97316", desc:"Crime, the law in practice & international law" },
  { id:"economics",              label:"Economics",                 short:"ECON",    icon:"\uD83D\uDCCA", color:"#84CC16", desc:"Macro & microeconomics, trade & government policy" },
  { id:"business_studies",       label:"Business Studies",          short:"BUS STD", icon:"\uD83D\uDCBC", color:"#EC4899", desc:"Operations, marketing, finance & human resources" },
];

// VCE subject metadata for Year 12 subject picker
export const VCE_SUBJECTS = [
  { id:"english",              label:"English",               short:"ENG",    icon:"\uD83D\uDCD6", color:"#0D9488", desc:"Text analysis, creative & persuasive writing" },
  { id:"mathematical_methods", label:"Mathematical Methods",  short:"MATH",   icon:"\u222B",       color:"#8B5CF6", desc:"Calculus, probability & algebra" },
  { id:"further_mathematics",  label:"Further Mathematics",   short:"FURT",   icon:"\uD83D\uDCD0", color:"#06B6D4", desc:"Statistics, networks, geometry & financial maths" },
  { id:"specialist_mathematics",label:"Specialist Mathematics",short:"SPEC",  icon:"\uD83E\uDDEE", color:"#7C3AED", desc:"Vectors, complex numbers, mechanics & proof" },
  { id:"biology",              label:"Biology",               short:"BIO",    icon:"\uD83D\uDD2C", color:"#10B981", desc:"Cell biology, genetics, evolution & ecosystems" },
  { id:"chemistry",            label:"Chemistry",             short:"CHEM",   icon:"\u2697\uFE0F", color:"#F59E0B", desc:"Organic, analytical & physical chemistry" },
  { id:"physics",              label:"Physics",               short:"PHYS",   icon:"\u269B\uFE0F", color:"#3B82F6", desc:"Mechanics, electromagnetism, thermodynamics & modern physics" },
  { id:"legal_studies",        label:"Legal Studies",         short:"LEGAL",  icon:"\u2696\uFE0F", color:"#F97316", desc:"Crime, civil law & the justice system" },
  { id:"economics",            label:"Economics",             short:"ECON",   icon:"\uD83D\uDCCA", color:"#84CC16", desc:"Micro & macroeconomics, trade & economic policy" },
  { id:"accounting",           label:"Accounting",            short:"ACCT",   icon:"\uD83E\uDDFE", color:"#0EA5E9", desc:"Recording, reporting & interpreting financial data" },
  { id:"business_management",  label:"Business Management",   short:"BUS MGT",icon:"\uD83D\uDCBC", color:"#EC4899", desc:"Planning, operations, human resources & finance" },
  { id:"global_politics",      label:"Global Politics",       short:"GLOB POL",icon:"\uD83C\uDF0D",color:"#6366F1", desc:"Power, sovereignty, globalisation & human rights" },
  { id:"history_revolutions",  label:"History: Revolutions",  short:"HIST REV",icon:"\u26A1\uFE0F",color:"#EF4444", desc:"American, French, Russian & Chinese revolutions" },
];

// Writing subjects use extended-response only — never MCQ practice, never interactive.
export function isWritingSubject(subject) {
  return subject === 'writing' || (typeof subject === 'string' && subject.endsWith('_writing'));
}

// Which subjects show the Interactive mode button per exam program.
// IDs must match EXAM_SUBJECTS IDs above (what appears on-screen), AND questions
// must exist in the question bank with that exact subject ID for that program.
// HSC and VCE are intentionally absent — Y12 uses ExamMode only.
export const INTERACTIVE_ENABLED = {
  naplan:        ['reading', 'numeracy', 'language'],
  selective_nsw: ['reading', 'thinking'],   // bank uses 'maths' for numeracy — mismatch, exclude
  oc:            ['reading', 'thinking'],   // same mismatch
  acer:          [],                        // bank uses maths/humanities/thinking; screen shows reading/numeracy/writing
  icas:          ['english', 'science'],    // bank uses 'maths' for numeracy — mismatch, exclude
  ignite:        [],                        // no questions in bank
  vic_selective: [],                        // no questions in bank
};

export function isInteractiveEnabled(examProgram, subject) {
  return (INTERACTIVE_ENABLED[examProgram] ?? []).includes(subject);
}

// All possible year levels across all programs
export const ALL_YEARS = [
  { id:"y3",  label:"Year 3",  age:"Ages 8\u20139",   color:"#0D9488" },
  { id:"y4",  label:"Year 4",  age:"Ages 9\u201310",  color:"#06B6D4" },
  { id:"y5",  label:"Year 5",  age:"Ages 10\u201311", color:"#8B5CF6" },
  { id:"y6",  label:"Year 6",  age:"Ages 11\u201312", color:"#F59E0B" },
  { id:"y7",  label:"Year 7",  age:"Ages 12\u201313", color:"#10B981" },
  { id:"y8",  label:"Year 8",  age:"Ages 13\u201314", color:"#EF4444" },
  { id:"y9",  label:"Year 9",  age:"Ages 14\u201315", color:"#F59E0B" },
  { id:"y12", label:"Year 12", age:"Ages 17\u201318", color:"#7C3AED" },
];

// Year levels shown per exam program
export const EXAM_YEARS = {
  naplan:        ["y3","y5","y7","y9"],
  selective_nsw: ["y6"],
  oc:            ["y4"],
  acer:          ["y5","y6"],
  ignite:        ["y6"],
  vic_selective: ["y8"],
  icas:          ["y3","y5","y7","y9"],
  hsc:           ["y12"],
  vce:           ["y12"],
};

// Plan access rules: which exams each plan unlocks
export const PLAN_ACCESS = {
  essential:  ["naplan","icas"],
  plus:       ["naplan","icas"],
  selective:  ["naplan","selective_nsw","oc","icas"],
  allaccess:  ["naplan","selective_nsw","oc","acer","ignite","icas","vic_selective","hsc","vce"],
  trial:      ["naplan","selective_nsw","oc","acer","ignite","icas","vic_selective","hsc","vce"],
};

// Legacy YEARS for backward compat
export const YEARS = ALL_YEARS;

// ── PRICING TIERS ─────────────────────────────────────────────
export const PLANS = [
  {
    id: "essential",
    name: "NAPLAN Essential",
    price: 9.99,
    color: "#0D9488",
    icon: "\u{1F4CB}",
    features: ["All NAPLAN questions", "Progress tracking", "Lumi hints", "Year 3, 5, 7 & 9"],
    exams: ["naplan"],
    highlight: false,
  },
  {
    id: "plus",
    name: "NAPLAN Plus",
    price: 14.99,
    color: "#8B5CF6",
    icon: "\u2B50",
    features: ["Everything in Essential", "AI writing feedback", "Lumi chat tutor", "Diagnostic insights"],
    exams: ["naplan"],
    highlight: true,
    badge: "Most Popular",
  },
  {
    id: "selective",
    name: "Selective Prep",
    price: 24.99,
    color: "#F59E0B",
    icon: "\u{1F3C6}",
    features: ["Everything in Plus", "Selective NSW questions", "OC Test questions", "Thinking Skills training"],
    exams: ["naplan", "selective_nsw", "oc"],
    highlight: false,
  },
  {
    id: "allaccess",
    name: "All Access",
    price: 34.99,
    color: "#EF4444",
    icon: "\u{1F680}",
    features: ["Everything in Selective", "ACER / IGNITE", "ICAS", "Sibling accounts (up to 3)", "Priority support"],
    exams: ["naplan", "selective_nsw", "oc", "acer", "icas"],
    highlight: false,
    badge: "Best Value",
  },
];

export const NAPLAN_CRITERIA = {
  reading: [
    "Literal comprehension \u2014 directly stated information",
    "Inferential comprehension \u2014 implied meaning",
    "Vocabulary knowledge \u2014 word meaning in context",
    "Text structure and organisation",
    "Author's purpose and audience",
    "Evaluating and reflecting on texts",
  ],
  writing: [
    "Audience and purpose \u2014 writing for effect",
    "Text structure \u2014 logical organisation",
    "Ideas \u2014 relevant and developed content",
    "Character and setting \u2014 narrative craft",
    "Vocabulary \u2014 precise and varied word choice",
    "Cohesion \u2014 paragraphs and linking devices",
    "Punctuation \u2014 accurate and effective use",
    "Spelling \u2014 correct standard Australian spelling",
    "Sentence structure \u2014 varied and controlled",
  ],
  language: [
    "Spelling \u2014 phonics, morphology, visual patterns",
    "Grammar \u2014 sentence structure and word classes",
    "Punctuation \u2014 full stops, commas, apostrophes",
    "Parts of speech \u2014 nouns, verbs, adjectives, adverbs",
    "Verb tense \u2014 consistency and accuracy",
    "Subject-verb agreement",
  ],
  numeracy: [
    "Number and algebra \u2014 patterns and relationships",
    "Measurement and geometry \u2014 space and shape",
    "Statistics and probability \u2014 data interpretation",
    "Fractions, decimals and percentages",
    "Place value and number sense",
    "Problem solving and reasoning",
  ],
};

// ── NAPLAN WRITING PROMPTS ──────────────────────────────────────
export const WRITING_PROMPTS = {
  y3: [
    { id:"y3p1", type:"narrative",  title:"A Surprise Discovery",       prompt:"Write a story about a character who discovers something unexpected. It could be in their backyard, at school, or somewhere else entirely. Use vivid details to bring the discovery to life." },
    { id:"y3p2", type:"persuasive", title:"Our School Needs a Garden",  prompt:"Write to persuade your principal that your school should have a vegetable garden. Give at least two clear reasons why it would benefit students." },
    { id:"y3p3", type:"narrative",  title:"The Best Day",               prompt:"Write a story about the best day a character ever had. What made it so special? What happened, and how did it make them feel?" },
  ],
  y5: [
    { id:"y5p1", type:"narrative",  title:"The Door at the End of the Hall", prompt:"Write a story about a character who notices a door they have never seen before. What happens when they open it? Where does it lead?" },
    { id:"y5p2", type:"persuasive", title:"Screen Time for Students",        prompt:"Write a persuasive text arguing whether students should have more or less screen time outside of school. Use evidence and clear reasoning to support your view." },
    { id:"y5p3", type:"narrative",  title:"Lost and Found",                  prompt:"Write a story in which a character loses something important \u2014 and what happens when they find it again (or don't). Show how this experience changes them." },
    { id:"y5p4", type:"persuasive", title:"Animals in Zoos",                 prompt:"Write a persuasive text arguing whether animals should or should not be kept in zoos. Develop a clear position with supporting evidence and address opposing views." },
  ],
  y7: [
    { id:"y7p1", type:"narrative",  title:"The Last Message",          prompt:"Write a story that begins with a character receiving a mysterious message. Who sent it? What does it mean? What do they do? Build tension and develop your character's response." },
    { id:"y7p2", type:"persuasive", title:"Social Media Age Limits",   prompt:"Write a persuasive text arguing whether there should be a minimum age for using social media. Develop a sophisticated argument with evidence and address counterarguments." },
    { id:"y7p3", type:"narrative",  title:"Two Sides",                 prompt:"Write a story in which two characters experience the same event very differently. Show how perspective shapes what people see, feel and believe." },
    { id:"y7p4", type:"persuasive", title:"The Future of School",      prompt:"Write a persuasive text arguing whether traditional classroom schooling should be replaced, reduced or preserved. Use evidence and engage with the complexity of the issue." },
  ],
  y9: [
    { id:"y9p1", type:"narrative",  title:"The Weight of a Secret",           prompt:"Write a story in which a character is keeping a secret that is affecting them deeply. Explore the tension between honesty and protection. Show rather than tell." },
    { id:"y9p2", type:"persuasive", title:"Artificial Intelligence in Education", prompt:"Write a sophisticated persuasive text arguing whether artificial intelligence tools should be used by students in schools. Address complexity, evidence and counterarguments." },
    { id:"y9p3", type:"narrative",  title:"A Different Kind of Courage",      prompt:"Write a story about a character who shows courage \u2014 but not the physical kind. What does moral, emotional or intellectual courage look like? Develop character with depth." },
    { id:"y9p4", type:"persuasive", title:"The Obligation to Speak Out",      prompt:"Write a persuasive text arguing whether individuals have an obligation to speak out against injustice, even at personal cost. Engage with the ethical complexity." },
  ],
};

// ── NAPLAN WRITING CRITERIA ─────────────────────────────────────
export const WRITING_CRITERIA = {
  narrative: [
    { id:"audience",   label:"Audience",           max:6, desc:"Engages and suits the intended reader throughout" },
    { id:"structure",  label:"Text Structure",     max:4, desc:"Orientation, complication and resolution \u2014 the narrative arc" },
    { id:"ideas",      label:"Ideas",              max:5, desc:"Originality, relevance and development of content" },
    { id:"character",  label:"Character & Setting",max:4, desc:"Character development and creation of setting/atmosphere" },
    { id:"vocab",      label:"Vocabulary",         max:5, desc:"Range, precision and effectiveness of word choices" },
    { id:"cohesion",   label:"Cohesion",           max:4, desc:"Flow between ideas \u2014 pronoun reference, connectives, transitions" },
    { id:"paragraphs", label:"Paragraphing",       max:2, desc:"Effective use of paragraphs to organise narrative" },
    { id:"sentences",  label:"Sentence Structure", max:6, desc:"Variety, complexity and correctness of sentences" },
    { id:"punctuation",label:"Punctuation",        max:5, desc:"Accuracy and effectiveness of punctuation" },
    { id:"spelling",   label:"Spelling",           max:6, desc:"Accuracy of common and challenging words" },
  ],
  persuasive: [
    { id:"audience",   label:"Audience",           max:6, desc:"Effectively persuades and engages the intended reader" },
    { id:"structure",  label:"Text Structure",     max:4, desc:"Introduction, body arguments and conclusion" },
    { id:"ideas",      label:"Ideas",              max:5, desc:"Quality of arguments, evidence and engagement with complexity" },
    { id:"persuasive_devices", label:"Persuasive Devices", max:4, desc:"Rhetorical techniques \u2014 evidence, counterarguments, emotive language" },
    { id:"vocab",      label:"Vocabulary",         max:5, desc:"Precision and formality of vocabulary for persuasion" },
    { id:"cohesion",   label:"Cohesion",           max:4, desc:"Logical flow between arguments and transitions" },
    { id:"paragraphs", label:"Paragraphing",       max:2, desc:"TEEL/PEEL structure and paragraph organisation" },
    { id:"sentences",  label:"Sentence Structure", max:6, desc:"Variety and sophistication of sentence construction" },
    { id:"punctuation",label:"Punctuation",        max:5, desc:"Accuracy and use of punctuation for effect" },
    { id:"spelling",   label:"Spelling",           max:6, desc:"Accuracy of spelling" },
  ],
};

// ── CONTENT SAFETY ────────────────────────────────────────────
export const BLOCKED_PATTERNS = [
  /\b(fuck|shit|bitch|bastard|asshole|cunt|damn|crap|piss|cock|dick|pussy|whore|slut)\b/i,
  /\b(sex|porn|naked|nude|boob|breast|penis|vagina|condom|masturbat|orgasm)\b/i,
  /\b(kill|murder|suicide|shoot|stab|bomb|terrorist|weapon|gun|knife|blood|die|death|hurt)\b/i,
  /\b(drug|weed|marijuana|cocaine|heroin|meth|pills|alcohol|beer|wine|drunk)\b/i,
  /\b(cut myself|hurt myself|self.harm|self harm|end my life|want to die)\b/i,
  // Slurs/hate-speech — note: do NOT block the standalone word "hate" (students saying "I hate studying" is a wellbeing signal, not inappropriate content)
  /\b(nigger|faggot|retard|nazi|racist|stupid kids)\b/i,
];

export const REDIRECT_RESPONSES = [
  "That's not something I can help with! Let's get back to your practice \u2014 you're doing great! \u{1F4DA}",
  "Oops, let's keep our conversation focused on your studies! What question would you like help with? \u2728",
  "I'm only here to help with exam prep! Ask me about maths, reading, or any of your practice questions. \u{1F3AF}",
  "Let's stay on track with your practice! Is there a question you're finding tricky? I'd love to help! \u{1F4D6}",
];

// Safe system prompt for Lumi
export const LUMI_SAFE_SYSTEM = `You are Lumi, a friendly and encouraging AI tutor for Australian students in Years 3\u201312 (primary and secondary).

SCOPE \u2014 you can and SHOULD answer any question within the Australian Curriculum / school syllabus:
- Exam programs: NAPLAN (Years 3, 5, 7, 9), NSW Selective (Year 6), OC Test (Year 4), ACER Scholarship, IGNITE (SA), VIC Selective, HSC (NSW Year 11\u201312 / NESA), VCE (VIC Units 1\u20134 / VCAA).
- Subjects: English (reading, writing, grammar, vocabulary, inference, literature, textual analysis), Mathematics (number, algebra, geometry, calculus, statistics), Science (biology, chemistry, physics, general science including everyday phenomena like "why is the sky blue" or "how do plants grow"), HASS (history, geography, civics, economics), Thinking Skills, Reasoning, Legal Studies, Business, Psychology, PDHPE, Visual Arts, Drama, Music.
- Any reasonable follow-up or curiosity question that a Year 3\u201312 Australian student might ask.

SUBJECT CONTEXT IS A HINT, NOT A RESTRICTION:
- The student's current lesson or subject tab is provided as CONTEXT to help you pitch examples at the right level \u2014 it is NOT a gate.
- If a student opens Lumi from a Year 3 Maths lesson and asks about photosynthesis, quadratic equations, or Le Chatelier's principle \u2014 answer the actual question at the appropriate curriculum level, do not refuse.
- If a student mentions they are doing HSC or VCE, lift your answer to HSC/VCE depth accordingly, even if the page they came from was a younger-year lesson.
- Never say "I only help students aged 8\u201314" or "I can only help with [current subject]". You help Years 3\u201312 across all school subjects.

WELLBEING TRIGGERS (DUTY OF CARE):
If the student's message contains expressions of distress, anxiety, overwhelm, or self-doubt \u2014 examples: "I hate studying", "going to fail", "I'm dumb", "I give up", "I can't do this", "freaking out", "so stressed", "anxious", "I don't understand anything", "want to give up", "everyone's better than me", "my parents will be mad", or similar \u2014 respond in this order:
1. VALIDATE the feeling first: "It sounds like you're feeling really overwhelmed right now \u2014 that's completely normal and it happens to every student at some point."
2. OFFER PERSPECTIVE: "Even the strongest students feel this way sometimes. Feeling stuck is part of how learning actually works."
3. SUGGEST A SMALL ACTION: "Sometimes a 5-minute break helps reset your brain. When you're ready, we can tackle just one tiny thing together."
4. GENTLY OFFER CHOICE: "Would you like to take a short break, or try one small thing together \u2014 whatever you pick is fine."
Do NOT pivot immediately to academic content. Do NOT dismiss the feeling. A student who feels heard is far more likely to keep going.
If the student mentions self-harm, wanting to die, or severe ongoing distress, acknowledge with care and suggest they talk to a trusted adult (parent, teacher, school counsellor) or contact Kids Helpline 1800 55 1800.

TYPO & SPELLING TOLERANCE:
Students are often children typing fast and making spelling mistakes. Be generous:
- If you can reasonably infer the intended word (e.g. "photosinthesis" \u2192 photosynthesis, "equasion" \u2192 equation, "meosis" \u2192 meiosis, "wat" \u2192 what, "quadratik" \u2192 quadratic, "hypoteneus" \u2192 hypotenuse), answer the intended question.
- Do NOT refuse, mock, or ask for clarification for minor typos. Just help.

HARD SAFETY RULES \u2014 NEVER BREAK:
- Never discuss violence, weapons, drugs, alcohol, sexual content, or other content inappropriate for minors.
- Never help with homework cheating where the student is being assessed in real time (exams, tests) \u2014 for practice questions, teach method not just answers.
- Never use profanity, slurs, or crude language.
- Never provide personal contact details, addresses, or request any personal information beyond first name.

ALWAYS:
- Be warm, encouraging, and patient.
- Match your language to the student's year level (simpler for Years 3\u20136, more technical vocabulary for Years 10\u201312).
- Celebrate effort and progress.
- Keep most responses under 180 words unless a detailed worked example or exam-depth explanation is genuinely needed.
- End with a brief encouraging phrase or offer to go deeper.

FORBIDDEN OPENINGS \u2014 NEVER start your response with any of these:
- "Hi!"
- "Hey!"
- "Hello!"
- "Great question!"
- "That's a great question!"
- "I'd love to help!"
- "Of course!"
- "Sure!"
- "Absolutely!"
- "Certainly!"
Start directly with the substance of your response or with a warm, specific acknowledgment of what the student is working on.

EXPLANATION STYLES \u2014 use different approaches when a student says they don't understand:
- STORY MODE: Turn the concept into a relatable story.
- REAL WORLD MODE: Show where the concept appears in real life.
- ANALOGY MODE: Connect to something familiar.
- STEP-BY-STEP MODE: Tiny numbered steps, check understanding at each one.
- EXAMPLE FIRST MODE: Lead with a worked example before the rule.

When a student says "I don't get it", "can you explain differently", "I'm confused", or "still don't understand":
1. Acknowledge their feeling warmly ("No worries at all!").
2. Switch to a COMPLETELY DIFFERENT explanation style from last time.
3. Use shorter sentences and simpler words.
4. Offer one of: a story, a real-world example, or tiny step-by-step.

DIFFICULTY-AWARE RESPONSES \u2014 adjust your tone based on question difficulty:
- BRONZE question wrong: "This is a great foundation question \u2014 let's nail it! Here's the key idea..."
- SILVER question wrong: "You're building really well \u2014 this one has a subtle trick. Look at..."
- GOLD question wrong: "Gold questions are genuinely tough \u2014 even strong students find these tricky! Let's break it down step by step..."
- After 2 consecutive wrong on same topic: "I notice this topic is challenging you. Want me to start from scratch with the basics?"

DISTRACTOR ANALYSIS \u2014 when explaining wrong answers:
- Always explain WHY the most tempting wrong answer (distractor) is incorrect.
- Use phrases like: "The trap here is...", "Many students choose X because... but that's wrong because..."

Only refuse to answer if the request genuinely falls outside Years 3\u201312 school curriculum AND there is no reasonable educational framing. When in doubt, answer helpfully.`;

// ── Mood definitions ──────────────────────────────────────────
export const MOODS = {
  idle: {
    label: "Ready",
    color: "#FBBF24",
    brows: "normal",
    mouth: "smile",
    blush: 0.3,
    anim: "idle",
    speech: null,
  },
  happy: {
    label: "Happy",
    color: "#10B981",
    brows: "normal",
    mouth: "smile",
    blush: 0.5,
    anim: "idle",
    speech: "Hey! Ready to learn something awesome?",
  },
  excited: {
    label: "Excited",
    color: "#F97316",
    brows: "raised",
    mouth: "grin",
    blush: 0.8,
    anim: "jump",
    speech: "Oh wow, let's go! This is going to be great!",
  },
  thinking: {
    label: "Thinking",
    color: "#8B5CF6",
    brows: "furrow",
    mouth: "flat",
    blush: 0.15,
    anim: "think",
    speech: "Hmm, let me think about this carefully.",
  },
  explaining: {
    label: "Explaining",
    color: "#3B82F6",
    brows: "raised",
    mouth: "open_sm",
    blush: 0.4,
    anim: "talk",
    speech: "So here is how it works. Pay close attention!",
  },
  correct: {
    label: "Correct!",
    color: "#10B981",
    brows: "raised",
    mouth: "grin",
    blush: 0.9,
    anim: "celebrate",
    speech: "Yes! That is exactly right! You are on fire!",
  },
  wrong: {
    label: "Try again",
    color: "#F97316",
    brows: "worried",
    mouth: "ohno",
    blush: 0.25,
    anim: "shake",
    speech: "Not quite, but that is how we learn. Let me explain.",
  },
  sad: {
    label: "Keep going",
    color: "#60A5FA",
    brows: "worried",
    mouth: "sad",
    blush: 0.2,
    anim: "droop",
    speech: "Don't give up. Every expert was once a beginner.",
  },
  celebrate: {
    label: "Amazing!",
    color: "#10B981",
    brows: "raised",
    mouth: "grin",
    blush: 1.0,
    anim: "celebrate",
    speech: "Yes! You got it! I knew you could do it!",
  },
};

// ── Profile-aware key helper ───────────────────────────────
export function profileKey(key, profileId) {
  return profileId ? `${key}_${profileId}` : key;
}

// Writing for exams other than NAPLAN: one timed task, marked by Lumi on the exam's own criteria. Prompts live in
// public/exam/writing/<program>-<year>.json. The criteria are our marking guide, built from each test's published
// description of what the writing task assesses (they are not an official rubric):
//   NSW Selective (education.nsw.gov.au practice papers): "select, develop and organise ideas and communicate them
//     effectively in writing", thinking about "the organisation and layout of your response"; one task, 30 minutes,
//     many text types (advice sheet, newspaper report, diary entry, ...).
//   VIC Selective (Edutest test description): punctuation, creativity, construction, grammar, spelling and relevance to
//     the task; a creative or persuasive piece.
export const EXAM_WRITING = {
  selective_nsw: {
    name: 'NSW Selective Writing Test',
    howItWorks: 'You get one writing task. It could be a story, a diary entry, a letter, a newspaper report, an advice sheet, a speech or a persuasive piece. You won\'t know which until you start, just like the real test.',
    criteria: [
      { id: 'ideas', label: 'Ideas and content', max: 10, desc: 'Selects relevant, thoughtful and original ideas that answer every part of the task, and develops them with specific detail, examples or description.' },
      { id: 'structure', label: 'Structure and layout', max: 8, desc: 'Organises the response clearly for its text type: an effective opening and ending, logical paragraphs, and the layout the form needs (headline, greeting, date, headings or sections).' },
      { id: 'language', label: 'Language and style', max: 8, desc: 'Precise, varied vocabulary and sentence structures, and a voice and tone that suit the audience and purpose of the task.' },
      { id: 'conventions', label: 'Spelling, punctuation and grammar', max: 6, desc: 'Accurate spelling, punctuation (including dialogue and lists) and grammar, so the writing reads smoothly.' },
    ],
  },
  vic_selective: {
    name: 'VIC Selective Writing Test',
    howItWorks: 'You get one writing task: either a creative piece or a persuasive piece. You won\'t know which until you start, just like the real test.',
    criteria: [
      { id: 'relevance', label: 'Relevance to the task', max: 8, desc: 'Responds directly and fully to the prompt, keeping every part of the piece connected to it.' },
      { id: 'creativity', label: 'Creativity and ideas', max: 10, desc: 'Original, engaging ideas (or, for persuasive writing, convincing arguments) developed with specific, well-chosen detail and evidence.' },
      { id: 'construction', label: 'Construction', max: 8, desc: 'A clear structure with a strong opening and conclusion, well-formed paragraphs, cohesive links, and varied, controlled sentences.' },
      { id: 'conventions', label: 'Spelling, punctuation and grammar', max: 6, desc: 'Accurate spelling, punctuation and grammar throughout.' },
    ],
  },
};
// ACER (acer.org scholarship test pages): primary level "2 extended responses in different genres", 20 minutes each,
// "assessed in terms of the quality of content and ideas, and the structure of expression"; secondary level "two topics
// for writing ... different styles of writing", 25 minutes each. Each practice test here is one of the two tasks.
// IGNITE (ACER's HAST-style entry test, SA): one Written Expression task, 25 minutes.
const ACER_STYLE_CRITERIA = [
  { id: 'content', label: 'Content and ideas', max: 10, desc: 'Thoughtful, original and relevant ideas that respond fully to the topic, developed with specific detail, examples or description.' },
  { id: 'structure', label: 'Structure', max: 8, desc: 'A clear shape for the chosen genre: an engaging opening, well-ordered paragraphs that build, and a satisfying conclusion.' },
  { id: 'expression', label: 'Expression', max: 8, desc: 'Precise, varied vocabulary and sentence structures, and a voice and tone that suit the genre and audience.' },
  { id: 'conventions', label: 'Spelling, punctuation and grammar', max: 6, desc: 'Accurate spelling, punctuation and grammar throughout.' },
];
EXAM_WRITING.acer = {
  name: 'ACER Scholarship Writing Test',
  minutesByYear: { y5: 20, y6: 25 },
  howItWorks: 'The real test has two writing tasks in different genres (20 minutes each in Year 5, 25 minutes each in Year 6). Each practice test is one of them, timed like the real task, and you won\'t know the genre until you start.',
  criteria: ACER_STYLE_CRITERIA,
};
EXAM_WRITING.ignite = {
  name: 'IGNITE Written Expression Test',
  minutesByYear: { y6: 25 },
  howItWorks: 'You get one writing task to respond to in 25 minutes. It could ask for a story, a persuasive piece, a reflection or a description, often inspired by a short stimulus.',
  criteria: ACER_STYLE_CRITERIA,
};

export const WRITING_TYPE_LABELS = {
  narrative: '📖 Story', persuasive: '💬 Persuasive', diary: '📔 Diary entry', letter: '✉️ Letter', report: '📰 Newspaper report',
  advice: '🧭 Advice sheet', speech: '🎤 Speech', description: '🖼️ Description', recount: '🕰️ Recount', review: '⭐ Review',
  creative: '✨ Creative', article: '📰 Article', blog: '💻 Blog post', reflection: '💭 Reflection', response: '🗨️ Response to a stimulus',
};
